<script>
    // for svelte-leaflet
    import {getContext} from 'svelte';
    import L from 'leaflet';
    import "leaflet-usermarker/src/leaflet.usermarker.css";

    const {getMarker} = getContext(L.Marker);

    export let options = {};

    let icon;

    $: {
        icon = L.divIcon(options);
        getMarker().setIcon(icon);
    }

    export function getIcon() {
        return icon;
    }
</script>
